import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-recupera-mail',
  templateUrl: './recupera-mail.component.html',
  styleUrls: ['./recupera-mail.component.css']
})
export class RecuperaMailComponent implements OnInit {
  errMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 2400;
  msg:any;
  sysN:string="";
  envioMail:any;
  mail:any=[];

  constructor(private dataService: DataService, private router:Router) { }

  ngOnInit() {
    this.dataService.getMail('1').subscribe(
                      rows => {   
                              this.mail = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnMailsCargados());      
  }

  fnMailsCargados(){
    //console.log(this.mail)
  }  

  fnKeyPress(t, ev){
    //console.log(ev)
    this.errMsg="";
    if (!this.dataService.validKey(t, ev)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else{    
      if(ev.key=="Enter"){
        var u = <HTMLInputElement>document.getElementById("txtUsr");
        this.fnEnviarMail(u.value); 
        }
      return true;
    }
  }

  fnEnviarMail(u){
    if (u.length < 1){
      this.errMsg = "Ingresa un usuario válido!"
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
      return;
    }
    document.getElementById("divEnviarMail").style.display = "none";
    this.dataService.getMsg("RECUP",u).subscribe(
                            rows => {   
                                    this.msg = rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnMsgRecibido(u));     

  }

  fnMsgRecibido(u){
    //console.log(this.msg);
    if(this.msg){
      if(this.msg[0]){
        if(this.msg[0].t=="ERR"){
            this.errMsg = this.msg[0].v
            setTimeout(() => {
              this.errMsg = "";
              document.getElementById("divEnviarMail").style.display = "block";
            }, this.tiempoMsg);
            return;          
        }
        else{
          //console.log(this.msg[0].v);   m, u, n
          this.dataService.sendMail("RECUP", this.msg[0].v, u, this.msg[0].ad,this.mail[0].h, this.mail[0].p, this.mail[0].us, this.mail[0].pw, this.mail[0].ssl, this.mail[0].tsl).subscribe(
                            rows => {   
                                    this.envioMail = rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnEmailEnviado());     
        }
      }
    }
  }

  fnEmailEnviado(){
    //console.log("fnEmailEnviado()");
    //console.log(this.envioMail);
    if(Number(this.envioMail)==1){
        this.okMsg = "Se ha enviado la contraseña a su correo. (El correo podría llegar como spam)";
        setTimeout(() => {
          this.router.navigate(['login',]);
        },this.tiempoMsg);
    }
    else{
        this.errMsg = "Ha ocurrido un error al enviar la contraseña a su correo";
            setTimeout(() => {
              this.errMsg = "";
            }, this.tiempoMsg);

    }

  }

}
